import { useState } from "react";
import { FormularioTextosAdmin } from "./FormularioTextosAdmin";
import { FormularioConstantesAdmin } from "./FormularioConstantesAdmin";
import { FormularioIndicadoresAdmin } from "./FormularioIndicadoresAdmin";

export default function FormularioAdmin() {
  const [categoriaActual, setCategoriaActual] = useState("textos");

  return (
    <div className="p-4">
      {/* OPCIONES PRINCIPALES */}
      <div className="flex space-x-6 border-b pb-2 mb-4">
        <div
          className={`cursor-pointer btn-green ml-10 ${
            categoriaActual === "textos" ? "font-bold" : ""
          }`}
          onClick={() => setCategoriaActual("textos")}
        >
          Textos
        </div>

        <div
          className={`cursor-pointer btn-turquesa ml-10 ${
            categoriaActual === "configuracion" ? "font-bold" : ""
          }`}
          onClick={() => setCategoriaActual("constantes")}
        >
          Constantes
        </div>
        <div
          className={`cursor-pointer btn-rosa ml-10 ${
            categoriaActual === "configuracion" ? "font-bold" : ""
          }`}
          onClick={() => setCategoriaActual("indicadores")}
        >
           Indicadores
        </div>
      </div>

      {/* FORMULARIO DE TEXTOS */}
      {categoriaActual === "textos" && <FormularioTextosAdmin />}
      {categoriaActual === "constantes" && <FormularioConstantesAdmin />}
      {categoriaActual === "indicadores" && <FormularioIndicadoresAdmin />}
    </div>
  );
}
